<template>
  <svg
    width="17"
    height="17"
    viewBox="0 0 17 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9 1.44338L14.3612 4.53868C14.6706 4.71731 14.8612 5.04743 14.8612 5.4047V11.5953C14.8612 11.9526 14.6706 12.2827 14.3612 12.4613L9 15.5566C8.6906 15.7353 8.3094 15.7353 8 15.5566L2.63878 12.4613C2.32938 12.2827 2.13878 11.9526 2.13878 11.5953V5.4047C2.13878 5.04743 2.32938 4.71731 2.63878 4.53868L8 1.44338C8.3094 1.26474 8.6906 1.26474 9 1.44338Z"
      stroke="#9A9A9A"
      stroke-width="2"
    />
    <path
      d="M7.40767 4.72727L7.57102 9.77344H9.03054L9.19389 4.72727H7.40767ZM8.30256 12.103C8.55587 12.103 8.77367 12.013 8.95597 11.8331C9.13589 11.6532 9.22585 11.4354 9.22585 11.1797C9.22585 10.9287 9.13589 10.7145 8.95597 10.5369C8.77367 10.357 8.55587 10.267 8.30256 10.267C8.05871 10.267 7.84446 10.357 7.6598 10.5369C7.47277 10.7145 7.37926 10.9287 7.37926 11.1797C7.37926 11.3501 7.42306 11.5052 7.51065 11.6449C7.59588 11.7846 7.70833 11.8958 7.84801 11.9787C7.98532 12.0616 8.13684 12.103 8.30256 12.103Z"
      fill="#9A9A9A"
    />
  </svg>
</template>

<script setup></script>
